<template>
  <div class="loan-wrapper">
    <div class="spinner-container" v-if="isLoading">
      <base-spinner :is-loading="true" :is-local="true" class="spinner" />
    </div>
    <div class="loan-container" v-if="!isLoading">
      <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
      <div class="back-block" @click="back()">
        <img
          src="../../../public/custom/images/back-arrow.svg"
          class="back-img"
          alt="Back arrow"
        />
        <span class="back-btn-text">{{ $t("message.loanPage.back") }}</span>
      </div>
      <div class="loan-info-container">
        <div class="loan-title">{{ $t("message.loanPage.title") }}</div>
        <div class="loan-notice">{{ $t("message.loanPage.notice") }}</div>
        <div class="payment-heading">
          <div class="payment-date">{{ $t("message.loanPage.items.date") }}</div>
          <div class="payment-amount">{{ $t("message.loanPage.items.amount") }}</div>
          <div class="payment-debt">{{ $t("message.loanPage.items.total") }}</div>
          <div class="payment-percent">{{ $t("message.loanPage.items.percent") }}</div>
          <div class="payment-peni">{{ $t("message.loanPage.items.peni") }}</div>
        </div>
        <div class="payment-item-desktop-block">
          <div class="payment-item" v-for="item of item.Payment" :key="item.id">
            <div class="payment-date">
              {{ parsePaymentDate(item.response.finishedAt) }}
            </div>
            <div class="payment-amount">
              {{ (+item?.response?.amount / 100).toFixed(2) }}
            </div>
            <div class="payment-debt">{{ parsePaymentPrincipalDebt(item) }}</div>
            <div class="payment-percent">
              {{ parsePaymentInterestDebt(item) }}
            </div>
            <div class="payment-peni">{{ parsePenalty(item) }}</div>
          </div>
        </div>

        <div class="payment-item-mobile-block">
          <div class="payment-item-mobile" v-for="item of item.Payment" :key="item.id">
            <div class="top-line"></div>
            <div class="mobile-date">{{ parsePaymentDate(item.response.finishedAt) }}</div>
            <div class="mobile-amount">
              <div class="mobile-title">{{ $t("message.loanPage.items.amount") }}</div>
              <div>{{ (+item?.response?.amount / 100).toFixed(2) }}</div>
            </div>
            <div class="mobile-debt">
              <div class="mobile-title">{{ $t("message.loanPage.items.total") }}</div>
              <div>{{ parsePaymentPrincipalDebt(item) }}</div>
            </div>
            <div class="mobile-percent">
              <div class="mobile-title">{{ $t("message.loanPage.items.percent") }}</div>
              <div>{{ parsePaymentInterestDebt(item) }}</div>
            </div>
            <div class="mobile-peni">
              <div class="mobile-title">{{ $t("message.loanPage.items.peni") }}</div>
              <div>{{ parsePenalty(item) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSpinner from "../../components/base/BaseSpinner.vue";

export default {
  name: "Loan",
  inject: ["$httpService"],
  components: {
    BaseSpinner,
  },
  async created() {
    const id = this.$route.params.id;

    try {
      const item = await this.$httpService.loan.getLoanById(id);
      this.item = item.data;
    } catch (error) {
      this.back();
    }

    this.isLoading = false;
  },
  data() {
    return {
      isLoading: true,
      item: {},
    };
  },
  methods: {
    back() {
      this.$router.push({ name: "profile" });
    },
    parsePaymentDate(date) {
      const parsedDate = new Date(date).toLocaleDateString();
      const hours = new Date(date).getHours();
      const minutes = new Date(date).getMinutes();
      return `${parsedDate} ${hours}:${minutes}`;
    },
    parsePaymentPrincipalDebt(item) {
      if(item.length === 0) {
        return 0;
      } else {
        return ((item.PrincipalDebt.map(el => el.repaid_amount).reduce((acc, el) => acc + el, 0)) / 100).toFixed(2);
      }
    },
    parsePaymentInterestDebt(item) {
      if(item.length === 0) {
        return 0;
      } else {
        return ((item.InterestDebt.map(el => el.repaid_amount).reduce((acc, el) => acc + el, 0)) / 100).toFixed(2);
      }
    },
    parsePenalty(item) {
      if(item.length === 0) {
        return 0;
      } else {
        return ((item.Penalty.map(el => el.repaid_amount).reduce((acc, el) => acc + el, 0)) / 100).toFixed(2);
      }
    }
  },
  computed: {
    isHasPayments() {
      return this.item?.Payment.length > 0;
    },
  }
};
</script>

<style lang="scss" scoped>
.loan-wrapper {
  @include page-wrapper-with-header-and-footer;

  padding-top: 20px;
  box-sizing: border-box;
  background-color: var(--profile-page-bgc);
}
.loan-container {
  @include base-page-container;

  flex-direction: column;
  color: #121212;
}

.loan-info-container {
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
}

.spinner-container {
  @include base-page-container;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
  color: var(--profile-text-color);
}

.spinner-container::v-deep .loader-wrapper {
  width: auto;
}

.back-block {
  width: fit-content;
  height: 70px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.back-img {
  margin-right: 4px;
  height: 18px;
  width: 18px;
}

.back-btn-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  color: #878787;
}

.loan-title {
  margin-bottom: 30px;
  font-weight: 600;
  font-size: 26px;
  line-height: 35px;
  color: #101010;
}

.loan-notice {
  margin-bottom: 7px;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
}

.payment-heading {
  padding: 16px 20px;
  box-sizing: border-box;
  width: fit-content;
  display: flex;
  align-items: center;
  border-width: 1px 0px;
  border-style: solid;
  border-color: #cdcdcd;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #878787;
}

.payment-date {
  width: 160px;
  margin-right: 50px;
}

.payment-amount {
  width: 170px;
  margin-right: 50px;
}

.payment-debt,
.payment-percent,
.payment-peni {
  width: 100px;
  margin-right: 50px;
}

.payment-item-desktop-block {
  display: flex;
  flex-direction: column;
}

.payment-item-mobile-block {
  display: none;
  flex-direction: column;
}

.payment-item {
  padding: 20px;
  box-sizing: border-box;
  width: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eceef0;
  font-weight: 400;
  font-size: 18px;
  line-height: 135%;
  color: #121212;
}

.payment-item-mobile {
  display: flex;
  flex-direction: column;
}

.top-line {
  margin-bottom: 10px;
  width: 100%;
  height: 1px;
  background: #ECEEF0;
  border-radius: 3px;
}

.mobile-date {
  width: 100%;
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 18px;
  line-height: 135%;
  color: #121212;
}

.mobile-amount,
.mobile-debt,
.mobile-percent,
.mobile-peni {
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  color: #121212;
}

.mobile-peni {
  margin-bottom: 15px;
}

.mobile-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #878787;
}

.route-name {
  @include route-name;
  margin-bottom: 15px;
}

@media screen and (max-width: 965px) {
  .payment-heading {
    display: none;
  }

  .payment-item-desktop-block {
    display: none;
  }

  .payment-item-mobile-block {
    width: 100%;
    display: flex;
  }
}
</style>
